<template>
    <div class="wrapper-card">
        <div class="sidenav-wrapper" v-if="width > 1000">
            <SideNav />
        </div>
        <div class="content-wrapper">
            <EventManageHeader
                :counterOfferData.sync="counterOfferData"
                :mode="mode"
                :eventId="eventId"
                :eventDate.sync="eventDate"
                :userId="parseInt(userid)"
            />
            <AdvancedArtist
                :artist-id="artistId"
                :counterOfferData="counterOfferData"
                :eventId="eventId"
                :eventDate.sync="eventDate"
            />
        </div>
    </div>
</template>

<script>
    import AdvancedArtist from './AdvanceArtist.vue'
    import EventManageHeader from '../../booking-part/EventManageHeader.vue'
    import SideNav from '../../../parts/SideNav.vue'
    import checkScreen from '../../../../mixins/check-screen'
    export default {
        name: 'AdvancedArtistStep',
        mixins: [checkScreen],
        props: {
            counterOfferData: {
                type: Object
            },
            artistId: {
                type: Number
            }
        },
        components: {
            EventManageHeader,
            AdvancedArtist,
            SideNav
        },
        data() {
            return {
                eventId: null,
                eventDate: null,
                mode: 'artistEvent'
            }
        },
        created() {
            this.eventId = localStorage.getItem('eventId')
        },
        mounted() {
            this.eventDate = localStorage.getItem('eventDate')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .wrapper-card {
        max-width: 100%;
        overflow: hidden;
        @include flex-start;
        background: $black;
        gap: 58px;
        @media (max-width: 600px) {
            padding: 0;
            display: block;
        }
        .content-wrapper {
            flex: 0 1 90%;
        }
    }
</style>
